(function() {
	'use strict';

	angular.module('changdobels.wp-constants', [])
		.constant('TEMPLATE_URL', window.wpConstants.template_url)
		.constant('AJAX_URL', window.wpConstants.ajax_url)
		.constant('HTTP_TIMEOUT', window.wpConstants.ajax_timeout)
		.constant('ENVIRONMENT', window.wpConstants.environment);
})();